import React, { useState, useEffect, useRef } from 'react';

const KnowledgeFileEditor = ({ file, onSave, onClose, boardId, token }) => {
  const [name, setName] = useState(file.name || '');
  const [content, setContent] = useState(file.content || '');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setName(file.name || '');
    setContent(file.content || '');
    setSaved(false);
  }, [file._id]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(file._id, name, content);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  const handleFileUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', uploadedFile);
      const res = await fetch(`/api/boards/${boardId}/knowledge/${file._id}/upload`, {
        method: 'POST',
        headers: { 'x-auth-token': token },
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.msg || 'Upload failed');
        return;
      }
      const updated = await res.json();
      setName(updated.name);
      setContent(updated.content);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div
      className="fixed top-0 right-0 h-full z-[60] flex flex-col bg-white dark:bg-gray-800 shadow-2xl border-l border-gray-200 dark:border-gray-700"
      style={{ width: '45%', minWidth: '320px', maxWidth: '700px' }}
    >
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
        <span className="text-gray-400 dark:text-gray-500 text-sm">📄</span>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-1 text-sm font-bold text-gray-800 dark:text-gray-100 bg-transparent border-0 border-b border-transparent focus:border-primary-blue focus:ring-0 focus:outline-none px-1 py-0.5"
          placeholder="filename.md"
        />
        <input
          type="file"
          accept=".md,.txt"
          ref={fileInputRef}
          onChange={handleFileUpload}
          className="hidden"
        />
        <button
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          disabled={uploading}
          className="px-3 py-1 bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200 text-[10px] font-black uppercase rounded hover:bg-gray-300 dark:hover:bg-gray-500 transition-all disabled:opacity-50"
        >
          {uploading ? 'Uploading...' : '↑ Upload File'}
        </button>
        <button
          onClick={handleSave}
          disabled={saving}
          className="px-3 py-1 bg-gray-900 text-white text-[10px] font-black uppercase rounded hover:bg-black transition-all disabled:opacity-50"
        >
          {saving ? 'Saving...' : saved ? '✓ Saved' : 'Save'}
        </button>
        <button
          onClick={onClose}
          className="ml-1 text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 text-lg leading-none font-bold"
          title="Close"
        >
          ×
        </button>
      </div>

      {/* Editor */}
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="flex-1 w-full resize-none font-mono text-xs text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-800 p-4 focus:outline-none focus:ring-0 border-0"
        placeholder="# Knowledge File&#10;&#10;Write markdown here. Agents will use this as context."
        spellCheck={false}
      />
    </div>
  );
};

export default KnowledgeFileEditor;
